import PaymentTypeManager from 'app/src/payments/PaymentTypeManager';
import PendingPayment from 'app/src/payments/PendingPayment';

/**
 * Class definition of a gift card payment
 */
export default class GiftCardPayment extends PendingPayment {
  /**
   * Constructor
   *
   * @param amount {Decimal}   The amount of the gift card payment
   * @param creditAccountID {Number}  The ID of of the credit account associated with the gift card
   * @param saleID {Number}   The ID of the sale for the payment
   */
  constructor(amount = 0, creditAccountID = 0, saleID = 0) {
    super(
      amount,
      PaymentTypeManager.getPaymentIdForType(PaymentTypeManager.Types.GIFT_CARD),
      saleID
    );

    this._model.set('creditAccountID', creditAccountID);
  }
}
